import backgroundImages from "@components/Exclusives/FeedAccess/AccessCarousel/background-images";

export enum AccessType {
  TOP = "top",
  POST = "post",
  MUSIC = "music",
  VIDEO = "video",
  EXPERIENCE = "experience",
  CHAT = "chat",
  EVENT = "event",
  MERCH = "merch",
  DJ_SET = "dj_set",
}

export type AccessCarouselSetListEntry = {
  startSeconds: number;
  title: string;
  artist: string;
};

export interface AccessCarouselData {
  id: string; // Unique ID for transition
  type: AccessType | null;
  image: (typeof backgroundImages)[keyof typeof backgroundImages];
  title: string;
  subtitle?: string;
  fontSize?: number;
  unlocked?: boolean;
  songImage?: string;
  canPreview?: boolean;
  startDate?: string;
  /** Precomputed for render perf (avoid dayjs in render). */
  startDateMonth?: string;
  /** Precomputed for render perf (avoid dayjs in render). */
  startDateDay?: string;
  ctaText?: string;
  setListEntries?: AccessCarouselSetListEntry[];
}
